import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerNotificationComponent } from './notification-banner.component';

@NgModule({
  imports: [CommonModule, SharedModule, CoreModule],
  exports: [BannerNotificationComponent],
  declarations: [BannerNotificationComponent]
})
export class BannerNotificationModule {}
